import React from 'react'
import { Row } from 'antd'
import {
  Image,
  MenuContainer,
  MenuItem,
  MenuText
} from '../../../../shared.style'
import MetroBin from '../../../../assets/icons/metro-bin.png'

const MenuAccountBin = ({ history }) => {
  return (
    <MenuContainer>
      <Row justify="center">
        <MenuItem onClick={() => history.push(`/account/bins`)}>
          <Image src={MetroBin} alt="myBins" />
        </MenuItem>
      </Row>
      <Row justify="center">
        <MenuText>ถังขยะของฉัน</MenuText>
      </Row>
    </MenuContainer>
  )
}

export default MenuAccountBin



// WEBPACK FOOTER //
// ./src/pages/Account/components/MenuAccountBin/index.js